import { Box } from '@mui/material'
import React, { useContext } from 'react'
import Joyride from 'react-joyride'
import { rqx } from '../../../../../core/request/API'
import { env } from '../../../../../core/Env'
import { ToolContext } from '../../../../../core/context/ToolContext'

const DesktopTour = () => {
    const {tool_state, job_state} = useContext(ToolContext)
    const {desktopTour, desktopTourData} = job_state
    const steps = [

        {
            target: '.dashboard',
            title: "Dashboard",
            content: 'Your transaction summary.',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.jobPost',
            title: "Job Post",
            content: 'Empowers you to discover a wider range of job opportunities.',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.jobStatus',
            title: "Job Status",
            content: 'Allows you to effectively track and monitor the status of their job applications..',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.toolCategories',
            title: "Tool Categories",
            content: 'Your Tool Categories.',
            disableBeacon: true,
            placement: "right"
        },
    ]

    const Tourstyle = () => {
        const tourcss = {
            options: {
                zIndex: 1202,
                // width: view === '' ? '317px' : 'auto',
                borderRadius: '15px',
                width: '317px'

            },
            buttonClose: {
                display: 'none',
            },
            buttonNext: {
                fontFamily: "Inter",
                fontWeight: 500,
                backgroundColor: "#0070EF",
                padding: "8px",
                fontSize: "12px !important",
                borderRadius: "15px",
                color: "#fff",
                cursor: "pointer",
                textAlign: "center",
                width: "80px",
                height: '33px'
            },
            buttonSkip: {
                fontFamily: "Inter",
                fontWeight: 500,
                padding: "8px",
                fontSize: "12px !important",
                color: "#A3A3A3",
                cursor: "pointer",
                textAlign: "center",
                width: "80px",
                height: '33px',
                left: 0,
                marginRight: '2px',
                float: 'right'
            },
            tooltip: {
                minHeight: '140px',
                height: '100%',
                borderRadius: '15px',
            },
            tooltipFooter: {
                marginTop: 0,
                padding: '0px 16px 0px 16px',
                minHeight: '40px',
            },
            tooltipContent: {
                height: '100%',
                padding: '10px'
            },
            overlay: {
                height: '100%'
            },
        }
        return tourcss
    }

    const asyncTour = async (e) => {
        const data = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/create`,
          {
            user_id: parseInt(tool_state.userId.data),
            tool_id: parseInt(process.env.REACT_APP_TID_PSL),
            feature_name: 'jobPSLTour',
            personalization: [{ sf_name: 'jobPSLTour', status: 1 }]
          })
          if (data.msg === 'success') {
            desktopTourData.set([{
                  active: 1,
                  created_by: parseInt(tool_state.userId.data),
                  feature_name: "jobPSLTour",
                  personalization: "[{\"status\": 1, \"sf_name\": \"jobPSLTour\"}]",
                  tool_id: parseInt(process.env.REACT_APP_TID_PSL),
              }])
          }
      }
      
  return (
    <Box>
         <Joyride 
            steps={steps} styles={Tourstyle()} 
            run={desktopTour.data} 
            showSkipButton 
            continuous 
            hideBackButton  
            locale={{ skip: 'Close', last: 'Got it' }} 
            callback={(e)=>asyncTour(e)}              
            />
    </Box>
  )
}

export default DesktopTour
